module.exports = __webpack_public_path__ + "img/dot.fb64a53b.svg";